function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import { classnames } from '@bydesign-ui/utils';
import React from 'react';
import { usePrefixCls } from '@byte-design/config';
import { useProgressAnimation } from '../../hooks/useProgressAnimation';
import { Slot } from './slot';
export function Circle(props) {
  var _props$size = props.size,
      size = _props$size === void 0 ? 'md' : _props$size,
      percent = props.percent,
      className = props.className,
      _props$status = props.status,
      status = _props$status === void 0 ? 'normal' : _props$status,
      format = props.format,
      _props$width = props.width,
      width = _props$width === void 0 ? 120 : _props$width,
      extra = _objectWithoutProperties(props, ["size", "percent", "className", "status", "format", "width"]);

  var shape = 'circle';
  var circleStyle = useProgressAnimation(percent, true);
  var cls = classnames(usePrefixCls('progress', {
    shape: shape,
    size: size
  }), className);
  var isFailure = status === 'exception';
  var borderWidths = {
    md: 8,
    sm: 4,
    xs: 2
  };
  var fontSizes = {
    md: 20,
    sm: 16,
    xs: 12
  };
  var chooseSize = width;
  var chooseFontSize = fontSizes[size];
  var borderWidth = borderWidths[size];
  var perimeter = 2 * Math.PI * (chooseSize / 2 - borderWidth / 2);
  var strokeDasharray = "".concat(perimeter * percent / 100, " ").concat(perimeter * (1 - percent / 100));
  var percentStyles = {
    stroke: '#2890FF'
  };
  var baseStyles = {
    stroke: '#E4E9ED',
    success: '#66C23A',
    fail: '#F45858'
  };
  var textStyle = {
    fontSize: "".concat(chooseFontSize, "px"),
    lineHeight: "".concat(chooseFontSize + 8, "px"),
    color: '#333'
  };
  var color = isFailure ? baseStyles.fail : status === 'success' ? baseStyles.success : percentStyles.stroke;
  var text = status !== 'normal' || width <= 38 || typeof format === 'function' ? null : React.createElement("text", {
    x: chooseSize / 2,
    y: chooseSize / 2,
    textAnchor: "middle",
    style: textStyle,
    dominantBaseline: "central"
  }, "".concat(percent, "%"));
  return React.createElement("div", Object.assign({
    className: cls
  }, extra), React.createElement("svg", {
    width: chooseSize,
    height: chooseSize,
    viewBox: "0 0 ".concat(chooseSize, " ").concat(chooseSize)
  }, React.createElement("circle", {
    stroke: isFailure ? color : baseStyles.stroke,
    strokeWidth: borderWidth,
    fill: "transparent",
    cx: chooseSize / 2,
    cy: chooseSize / 2,
    r: Math.abs(chooseSize / 2 - borderWidth / 2)
  }), React.createElement("circle", {
    stroke: color,
    strokeWidth: percent > 0 ? borderWidth : 0,
    fill: "transparent",
    strokeDasharray: strokeDasharray,
    transform: "matrix(0, -1, 1, 0, 0, ".concat(chooseSize, ")"),
    strokeLinecap: "round",
    fillRule: "nonzero",
    strokeLinejoin: "round",
    cx: chooseSize / 2,
    cy: chooseSize / 2,
    r: Math.abs(chooseSize / 2 - borderWidth / 2),
    style: circleStyle
  }), text), width > 38 ? React.createElement(Slot, {
    status: status,
    percent: percent,
    format: format
  }) : null);
}